<script setup lang="ts">
import Check from '@/assets/icon-check.svg?skipsvgo'

interface Form {
  email: string
  firstName: string
}

const submitted = ref(false)

const submit = async (form: Form, node) => {
  try {
    await newsletter(form)
    submitted.value = true
    node.reset({ email: form.email })
  } catch ({ data: error }) {
    node.setErrors(error.data.errors.map(({ detail }) => detail))
  }
}
</script>

<template>
  <div class="flex justify-center shadow-[0_0_10px_rgba(0,0,0,0.16)] p-[15px] lg:p-[50px]">
    <div class="md:w-2/3">
      <FormKit
        type="form"
        #default="{ disabled, state: { dirty, loading } }"
        :actions="false"
        :incomplete-message="false"
        @submit-raw="submitted = false"
        @submit="submit"
      >
        <div class="newsletter grid rounded-[5px] md:justify-items-center">
          <div class="text-1 text-30 text-primary mb-[10px]">
            Newsletter
          </div>
          <div class="text-2 text-16 mb-[10px]">
            Nie przegap żadnej promocji, zdobywaj dodatkowe rabaty.
          </div>
          <div class="text-3 text-12 md:text-center">
            Od czasu do czasu będziemy wysyłać na Twoją skrzynkę e-mail oferty i najświeższe wiadomości związane z Go-Racing. Możesz zrezygnować z subskrypcji w dowolnym momencie, a my nie udostępnimy Twoich danych żadnym stronom trzecim.
          </div>

          <div class="input-1 w-full">
            <FormKit
              type="text"
              outer-class="w-full mb-[10px]"
              name="firstName"
              autocomplete="firstName"
              label="Imię*"
              placeholder="Imię*"
              validation="required"
              validation-visibility="blur"
              :validation-messages="{
                required: 'Pole imię nie może być puste.'
              }"
            />

            <FormKit
              type="email"
              outer-class="w-full mb-[10px]"
              name="email"
              autocomplete="email"
              label="E-mail*"
              placeholder="E-mail*"
              validation="required|email"
              validation-visibility="blur"
              :validation-messages="{
                required: 'Pole e-mail nie może być puste.',
                email: 'Błędny adres e-mail.'
              }"
            />
          </div>

          <div class="terms_and_conditions_privacy_policy">
            <FormKit
              type="checkbox"
              outer-class="mb-[10px]"
              name="rules"
              validation="accepted"
              validation-visibility="blur"
              :validation-messages="{
                accepted: 'Zaakceptuj regulamin.'
              }"
            >
              <template #suffix>
                <div>
                  Wyrażam zgodę na otrzymywanie newslettera, informacji handlowych o produktach i usługach oferowanych przez EMOTIVO sp. z o. o. i zapoznałem/zapoznałam się z
                  <NuxtLink to="/i/polityka-prywatnosci" target="_blank" class="underline">polityką prywatności</NuxtLink>.*
                </div>
              </template>
            </FormKit>

            <div v-if="submitted && !dirty" class="flex bg-green items-center gap-[20px] text-white px-[20px] py-[10px] mt-[10px]">
              <Check class="shrink-0" />
              E-mail został zapisany.
            </div>
          </div>

          <div class="button w-full md:w-[336px]">
            <FormKit
              type="submit"
              :disabled="disabled"
              input-class="btn btn-primary disabled:pointer-events-none disabled:bg-primary-disabled mt-[5px]"
            >
              Zapisz się <i class="icon-arrow-button text-10 ml-[5px]" />
              <LoadingIndicator v-if="loading" class="text-white h-[16px] w-[16px] ml-[5px] absolute" />
            </FormKit>
          </div>
        </div>
      </FormKit>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.newsletter {
  grid-template-areas:
    "text-1"
    "text-2"
    "input-1"
    "text-3"
    "terms_and_conditions_privacy_policy"
    "button";
  @screen md {
    grid-template-areas:
      "text-1"
      "text-2"
      "text-3"
      "input-1"
      "terms_and_conditions_privacy_policy"
      "button";
  }
}
.text-1 {
  grid-area: text-1;
}
.text-2 {
  grid-area: text-2;
}
.text-3 {
  grid-area: text-3;
}
.input-1 {
  grid-area: input-1;
}
.input-2 {
  grid-area: input-2;
}
.button {
  grid-area: button;
}
</style>
